import { render, staticRenderFns } from "./roomChoose.vue?vue&type=template&id=e987b5e8&scoped=true&"
import script from "./roomChoose.vue?vue&type=script&lang=js&"
export * from "./roomChoose.vue?vue&type=script&lang=js&"
import style0 from "./roomChoose.vue?vue&type=style&index=0&id=e987b5e8&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e987b5e8",
  null
  
)

export default component.exports